import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import { useSelector } from 'react-redux';
import classes from './TimesheetComment.module.scss';
import MainButton from '../../../../common/buttons/MainButton';
import { qtyAllowedForComment, qtyToShowComment } from '../../../../../utils/constants';

const textFieldStyles = {
  width: '448px',
  backgroundColor: 'white',
  borderRadius: '10px',
  '& .MuiOutlinedInput-notchedOutline': {
    border: '1px solid #D1D3D4',
    borderRadius: '10px'
  },
  color: '#283237',
  fontSize: '14px',
  fontWeight: '325',
  lineHeight: '17px',
  fieldset: {
    legend: {
      width: 'unset'
    }
  }
};

export default function TimesheetComment(props) {
  const { comment, changeHandler, disabled, author = '' } = props;

  const { t } = useTranslation();
  const isApprover = useSelector((state) => state.accessToParts.tAndEApprover);
  const [open, setOpen] = useState(false);
  const [newComment, setNewComment] = useState(comment);

  return (
    <div className={classes.commentWrapper}>
      <div
        role="presentation"
        className={`${classes.commentButton} ${disabled ? classes.disabled : ''}`}
        onClick={() => setOpen(true)}
      >
        {comment ? (
          <p className={`${classes.comment} ${classes.exists}`}>{comment}</p>
        ) : (
          <p className={classes.comment}>{t('dashboard.timesheet.table.comment')}</p>
        )}
        <ArrowForwardIosIcon sx={{ opacity: 0.1, fontSize: '12px' }} />
      </div>
      {open && (
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          sx={{
            '& .MuiPaper-root.MuiDialog-paper': {
              maxWidth: '100%',
              margin: '16px'
            },
            '& .MuiDialog-paper': {
              borderRadius: '20px',
              overflowY: 'visible',
              paddingBottom: '48px',
              backgroundColor: '#F6F7F9'
            }
          }}
        >
          <DialogTitle
            sx={{ display: 'flex', alignItems: 'center', justifyContent: !disabled ? 'space-between' : 'flex-end' }}
          >
            {!disabled && <p className={classes.dialogHeader}>{t('dashboard.timesheet.table.comment')}</p>}
            <div role="presentation" onClick={() => setOpen(false)} style={{ cursor: 'pointer' }}>
              <CloseIcon sx={{ color: '#77787B', fontSize: '32px' }} />
            </div>
          </DialogTitle>
          <DialogContent>
            {!disabled ? (
              <div className={classes.textFieldWrapper}>
                <TextField
                  value={newComment}
                  multiline
                  minRows={10}
                  onChange={(e) => {
                    if (e.target.value.length <= qtyAllowedForComment) setNewComment(e.target.value);
                  }}
                  sx={textFieldStyles}
                  placeholder={t('dashboard.timesheet.table.commentPlaceholder')}
                />
                {newComment.length >= qtyToShowComment && (
                  <p className={classes.counter}>{`${newComment.length}/${qtyAllowedForComment}`}</p>
                )}
              </div>
            ) : (
              <div className={classes.userComment}>
                <div className={classes.contractorName}>
                  {isApprover ? (
                    <p>{t('dashboard.timesheet.table.comment')}</p>
                  ) : (
                    <>
                      <p>{t('dashboard.timesheet.table.messagefrom')}</p>&nbsp;
                      <p>{author}</p>
                    </>
                  )}
                </div>
                <div className={classes.commentDisabled}>{newComment}</div>
              </div>
            )}
          </DialogContent>
          {!disabled && (
            <DialogActions sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <MainButton
                size="small"
                variant="primary"
                outlined={false}
                rounded
                action={() => {
                  changeHandler(newComment);
                  setOpen(false);
                }}
                forceWidth="204px"
              >
                {t('common.general.save')}
              </MainButton>
            </DialogActions>
          )}
        </Dialog>
      )}
    </div>
  );
}
